import { render, staticRenderFns } from "./contactEditSupplierDialog.vue?vue&type=template&id=4d131e9c&"
import script from "./contactEditSupplierDialog.vue?vue&type=script&lang=js&"
export * from "./contactEditSupplierDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports